/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo - Yeni İnsanlarla Tanış, Sohbet Et, Sosyalleş",
      "Yanlış telefon numarası",
      "Get the app",
      "Apple ile devam et",
      "Facebook ile devam et",
      "Google ile devam et",
      "Giriş yap",
      "Kaydol",
      "Devam etmek için lütfen giriş alanına gördüğünüz karakterleri girin.",
      "Devam",
      "Karakterleri girin",
      "Güvenlik kontrolü",
      "Yeniden yükle",
      "Kolayca hatırlayabileceğiniz yeni bir şifre oluşturun:",
      "Güncelle",
      "Şifreyi onayla",
      "Şifre en az {{num}} [[characters:num]]den oluşmalıdır",
      "Şifre",
      "Yeni şifre oluştur",
      "Badoo - The Blog",
      "Kariyer",
      "Sohbet",
      "Şehirler",
      "Çerezleri yönet",
      "Telif hakkı © 2006 – günümüz. Bumble. Her hakkı saklıdır.",
      "Apple ve Apple logosu, Apple Inc.'in ticari markalarıdır.{{__EOL__}}Google Play, Google LLC'nin ticari markasıdır.",
      "İndir",
      "Facebook",
      "Bizi takip edin",
      "Yardım Merkezi",
      "Instagram",
      "Dil",
      "LinkedIn",
      "Genel bakış",
      "Badoo, Bumble Inc.'in bir parçasıdır.",
      "Gizlilik politikası",
      "Güvenlik Merkezi",
      "Sitemap",
      "Modern Slavery Act açıklaması",
      "Hükümler ve koşullar",
      "Twitter",
      "E-postanızı ya da telefon numaranızı girin. Yeni şifre oluşturmanız için size bir mesaj göndereceğiz.",
      "Yeni şifre al",
      "E-postanızı veya telefon numaranızı yazınız",
      "Şifre yenileme",
      "Modeller sadece örnek amaçlı kullanılmıştır",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "Eşleşmek için beklemene gerek yok.{{__EOL__}}{{__EOL__}}Biraz daha derine inen sohbetlere dalın ve doğrudan iyi şeylere ulaşın. Bilirsin, birbirinizi gerçekten tanıyacağınız kısım.",
      "Sohbete hazır mısın?",
      "Kaydolarak, <a class=\"link\" href=\"{{terms_url}}\">Şartlar ve Koşullarımızı</a> kabul etmiş olursunuz. Verilerinizi nasıl kullandığımızı <a class=\"link\" href=\"{{privacy_url}}\">Gizlilik Politikamızda</a> öğrenin.",
      "Kendini iyi hissetmen için gerçek kişiliğini <br />daha fazla ortaya koymana yardımcı oluyoruz.",
      "Burası güvenle flört etmek için senin.",
      "Veya",
      "Zaten bir hesabın var mı?",
      "E-posta veya telefon numaranla kaydol",
      "Flörtleşmenin keyfini çıkar.{{__EOL__}}Özür dilemene gerek yok.",
      "Sadece sohbet etmek mi istiyorsun? Sorun değil.{{__EOL__}}Ciddi bir şeylere hazır mısın? Buna bayıldım.{{__EOL__}}{{__EOL__}}Ve eğer fikrini değiştirirsen kesinlikle bunu yapabilirsin.",
      "Buluşmak için burada",
      "Bir ilişkiye hazır",
      "Sohbete açık",
      "Aynı şeyi isteyen insanlarla tanışın.",
      "{{name}}, {{age}}",
      "Güvenliğiniz bizim bir numaralı önceliğimizdir.",
      "Güvenlik Merkezimiz, bugüne kadar güvenle ihtiyacınız olan tüm desteği içeren bir bilgi merkezidir.",
      "Güvenlik Merkezimizi ziyaret et",
      "Önce güvenlik,<br/>sonra ve her zaman.",
      "İlk andan itibaren işe yarayacağını düşündüm…",
      "İlk başlarda hiç ciddi bir ilişki aramıyordum…",
      "Badoo uygulamasındaki herkese tavsiyem kendisi olması olacaktır...",
      "Badoo Başarı Öyküleri",
      "Daha fazla başarı öyküsüne göz atın",
      "{{num}}__CUT__Puan",
      "Apple App Store",
      "Bize güven. 2006'dan bu yana milyonlarca (ve milyonlarca, milyonlarca) insanı bir araya getirdik.",
      "{{num}}M+__CUT__İndirme",
      "{{num}}M+",
      "Google Play Store",
      "Bu işi biliyoruz.",
      "E-postanız veya cep telefonunuzla giriş yapın",
      "Şifrenizi girin",
      "Şifrenizi mi unuttunuz?",
      "Kaydolun",
      "Bir hesabınız yok mu?",
      "Giriş",
      "Kaydol"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "plural": [
                  "karakter",
                  "karakter",
                  "karakter",
                  "karakter",
                  "karakter",
                  "karakter"
            ],
            "singular": [
                  "karakter",
                  "karakter",
                  "karakter",
                  "karakter",
                  "karakter",
                  "karakter"
            ]
      },
      "day": {
            "plural": [
                  "gün",
                  "gün",
                  "gün",
                  "gün",
                  "gün",
                  "gün"
            ],
            "singular": [
                  "gün",
                  "gün",
                  "gün",
                  "gün",
                  "gün",
                  "gün"
            ]
      },
      "hour": {
            "plural": [
                  "saat",
                  "saat",
                  "saat",
                  "saat",
                  "saat",
                  "saat"
            ],
            "singular": [
                  "saat",
                  "saat",
                  "saat",
                  "saat",
                  "saat",
                  "saat"
            ]
      },
      "minute": {
            "plural": [
                  "dakika",
                  "dakika",
                  "dakika",
                  "dakika",
                  "dakika",
                  "dakika"
            ],
            "singular": [
                  "dakika",
                  "dakika",
                  "dakika",
                  "dakika",
                  "dakika",
                  "dakika"
            ]
      },
      "month": {
            "plural": [
                  "ay",
                  "ay",
                  "ay",
                  "ay",
                  "ay",
                  "ay"
            ],
            "singular": [
                  "ay",
                  "ay",
                  "ay",
                  "ay",
                  "ay",
                  "ay"
            ]
      },
      "second": {
            "plural": [
                  "saniye",
                  "saniye",
                  "saniye",
                  "saniye",
                  "saniye",
                  "saniye"
            ],
            "singular": [
                  "saniye",
                  "saniye",
                  "saniye",
                  "saniye",
                  "saniye",
                  "saniye"
            ]
      },
      "year": {
            "plural": [
                  "yaş",
                  "yaş",
                  "yaş",
                  "yaş",
                  "yaş",
                  "yaş"
            ],
            "singular": [
                  "yaş",
                  "yaş",
                  "yaş",
                  "yaş",
                  "yaş",
                  "yaş"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
